import React, { useState } from 'react';
import ButtonOptions from '../../../../../../../components/NovoSistema/ButtonOptions';
import ButtonsGeneric from '../../../../../../../components/NovoSistema/ButtonsGeneric';
import ButtonsPlusAndCheck from '../../../../../../../components/NovoSistema/ButtonsPlusAndCheck';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import HeaderButtons from '../../../../../../../components/NovoSistema/HeaderButtons';
import InputCheckBox from '../../../../../../../components/NovoSistema/InputCheckBox';
import InputText from '../../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function ServicoAdd({ setOption }) {
  const [internalOption, setInternalOption] = useState('Principal');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Principal"
          border="#333F50"
          active={internalOption === 'Principal' ? true : false}
          yourFunction={() => setInternalOption('Principal')}
        />
        <ButtonOptions
          buttonName="Tributos e Retenções"
          border="#333F50"
          disabled={true}
          active={internalOption === 'Tributos e Retenções' ? true : false}
          yourFunction={() => setInternalOption('Tributos e Retenções')}
        />
        <ButtonOptions
          buttonName="Itens de Serviço"
          border="#333F50"
          active={internalOption === 'Itens de Serviço' ? true : false}
          yourFunction={() => setInternalOption('Itens de Serviço')}
        />
        <ButtonOptions
          buttonName="Integração G5 Phoenix"
          border="#333F50"
          disabled={true}
          active={internalOption === 'Âmbito Federal' ? true : false}
          yourFunction={() => setInternalOption('Âmbito Federal')}
        />
      </HeaderButtons>
      {internalOption === 'Principal' && (
        <div>
          <ContainerSection>
            <h3>Serviço</h3>
            <div>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Situação"
                  id="Situacao"
                  optionsArray={['Ativo', 'Inativo']}
                  widthPercentage="45%"
                />
                <InputCheckBox title="Recibo" id="Recibo" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Código" id="Codigo" widthPercentage="45%" />
                <SelectAndOptions
                  title="* Tipos de Serviço"
                  id="TiposDeServico"
                  optionsArray={['Prestado', 'Tomado']}
                  widthPercentage="45%"
                />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="*Descrição" id="Descricao" widthPercentage="60%" />
                <InputText title="Valor Unitário" id="Municipio" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Natureza da Operação"
                  id="NaturezaDaOperacao"
                  optionsArray={[
                    'Tributado',
                    'Isento',
                    'Imune',
                    'Exigibilidade Suspensa por Decisão Judicial',
                    'Exigibilidade Suspensa por Procedimento Administrativo',
                  ]}
                  widthPercentage="60%"
                />
                <InputText title="% Comissão" id="Municipio" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Código de Serviço do Município" id="CodeServicoMunicipio" widthPercentage="30%" />
                <InputText title="Descrição" id="DescricaoMunicipio" widthPercentage="30%" />
                <InputText title="CNAE" id="CNAE" widthPercentage="30%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions title="Código L.C 116/03" id="CodigoLC" optionsArray={['']} widthPercentage="100%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions title="NBS Lei L.C 12.741/12" id="NBSLei" optionsArray={['']} widthPercentage="20%" />
                <InputText title="Federal Nac.(%)" id="FederalNac" widthPercentage="20%" />
                <InputText title="Federal Imp.(%)" id="FederalImp" widthPercentage="20%" />
                <InputText title="Municipal(%)" id="Municipal" widthPercentage="20%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'Itens de Serviço' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Descrição" id="Descricao" widthPercentage="40%" />
                <InputText title="Valor Unitário" id="ValorUnitario" widthPercentage="40%" />
                <ButtonsPlusAndCheck buttonCheck={false} />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
